<div class="user-profile-form-container mat-elevation-z4">
  <app-header heading="User Profile" [subheading]="subheading"></app-header>

  <mat-divider class="my-divider"></mat-divider>

  <form [formGroup]="userForm" (ngSubmit)="save()" class="my-profile-form">
    <!-- <h2>User Profile</h2> -->

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>First Name</mat-label>
      <input matInput formControlName="first_name" maxlength="100" />
      <mat-error *ngIf="userForm.get('first_name')?.hasError('maxlength')">
        Maximum length is 100 characters.
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="last_name" maxlength="100" />
      <mat-error *ngIf="userForm.get('last_name')?.hasError('maxlength')">
        Maximum length is 100 characters.
      </mat-error>
    </mat-form-field>

    <div class="preferences-toggle" *ngIf="false">
      <a href="#" (click)="togglePreferences($event)">
        Preferences
        <mat-icon>{{
          preferencesCollapsed ? 'expand_more' : 'expand_less'
        }}</mat-icon>
      </a>
    </div>

    <div class="preferences-section" *ngIf="!preferencesCollapsed">
      <!-- <h3>Preferences</h3> -->
      <button
        mat-raised-button
        type="button"
        color="primary"
        class="add-pref-button"
        (click)="addPreference()"
      >
        Add Preference
      </button>
      <div class="preferences-list">
        <div
          formArrayName="preferences"
          *ngFor="let preference of preferences.controls; let i = index"
        >
          <div [formGroupName]="i" class="preference-item">
            <mat-form-field class="key-field" appearance="outline">
              <mat-label>Key</mat-label>
              <input
                matInput
                formControlName="key"
                maxlength="100"
                placeholder="Preference key"
              />
              <mat-error *ngIf="preference.get('key')?.hasError('maxlength')">
                Maximum length is 100 characters.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="value-field" appearance="outline">
              <mat-label>Value</mat-label>
              <input
                matInput
                formControlName="value"
                maxlength="200"
                placeholder="Preference value"
              />
              <mat-error *ngIf="preference.get('value')?.hasError('maxlength')">
                Maximum length is 200 characters.
              </mat-error>
            </mat-form-field>

            <button
              mat-icon-button
              class="remove-pref"
              type="button"
              color="warn"
              (click)="removePreference(i)"
              aria-label="Remove Preference"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="info-toggle" *ngIf="false">
      <a href="#" (click)="toggleInfo($event)">
        Additional Information
        <mat-icon>{{ infoCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
      </a>
    </div>

    <div class="info-section" *ngIf="!infoCollapsed || true">
      <!-- <h3 class="profile-form-header">Additional Information</h3> -->
      <mat-form-field
        class="full-width"
        appearance="outline"
        class="add-info-field"
      >
        <mat-label>Additional Information</mat-label>
        <textarea
          matInput
          formControlName="additional_info"
          rows="6"
          maxlength="500"
          [placeholder]="add_info_placeholder"
        ></textarea>
      </mat-form-field>
    </div>

    <span class="my-profile-message" *ngIf="user_message">
      <mat-icon>done</mat-icon>
      {{ user_message }}
    </span>

    <div class="form-actions">
      <button
        mat-raised-button
        type="submit"
        color="primary"
        class="save-button"
        [disabled]="!userForm.valid"
      >
        Save
      </button>
      <button mat-raised-button type="button" color="warn" (click)="cancel()">
        Cancel
      </button>
    </div>
  </form>
</div>
